import { z } from 'zod';

import { AdvisorRoleV4 } from '../../../../api/generated/cz.partners.pid.backofficegateway.pfsadvisordefinition';
import type { GetAdvisorIdSchemaErrorMessages } from '../../../../helpers/schemas/advisorIdSchema';
import { getAdvisorIdSchema } from '../../../../helpers/schemas/advisorIdSchema';
import { ALL_ADVISOR_ROLES } from '../const';

export const getAdvisorClientAccessFormSchema = (
	errorMessages?: GetAdvisorIdSchemaErrorMessages,
) => {
	const advisorIdSchema = getAdvisorIdSchema(errorMessages);
	return z.object({
		advisorId: advisorIdSchema.shape.advisorId.nullable(),
		roles: z.array(z.enum(AdvisorRoleV4)).default(ALL_ADVISOR_ROLES),
	});
};
